import React from 'react';

const TransportadoraContext = React.createContext();

export default TransportadoraContext;
